import { Svg404 } from "../assets";
import { Link, useNavigate } from "react-router-dom";

import { Helmet } from "react-helmet";
export default () => {
  const navigate = useNavigate();
  return (
    <>
      {" "}
      <div
        className="pagefour"
        style={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div
          className="pagefour__content"
          style={{
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            height: "100vh",
            flexDirection: "column",
          }}
        >
          <img src={Svg404} alt="svg" />

          <Link
            to="#"
            title="Back to Home"
            style={{
              marginTop: "20px",
            }}
            className="pagefour__content__button"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
};
